<div class="ds-group" role="list">
  <button *ngIf="currentExtra as extra" type="button" class="ds-row" role="listitem"
    [attr.aria-pressed]="isSelected(extra.hours)" (click)="pick(extra.hours)">
    <span class="ds-row-text">
      {{ extra.label }}
      <span class="ds-row-sub">{{ endsFor(extra.hours) }}</span>
    </span>
    <svg *ngIf="isSelected(extra.hours)" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
    </svg>
  </button>

  <button *ngFor="let p of presets" type="button" class="ds-row" role="listitem"
    [attr.aria-pressed]="isSelected(p.hours)" (click)="pick(p.hours)">
    <span class="ds-row-text">
      {{ p.label }}
      <span class="ds-row-sub">{{ endsFor(p.hours) }}</span>
    </span>
    <!-- Solar check-linear -->
    <svg *ngIf="isSelected(p.hours)" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
    </svg>
  </button>

  <button type="button" class="ds-row" role="listitem" [attr.aria-expanded]="customOpen" (click)="toggleCustom()">
    <span class="ds-row-text">
      Pick an end time
      <span class="ds-row-sub">Up to 10 days</span>
    </span>
    <svg *ngIf="customOpen" width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 13L9 17L19 7" />
    </svg>
  </button>

  <div class="ds-custom" *ngIf="customOpen">
    <div class="ds-custom-row">
      <input class="ds-input" type="date" [value]="customDate" (change)="customDate = $any($event.target).value"
        aria-label="End date" />
      <select class="ds-input ds-select" [value]="customTime" (change)="customTime = $any($event.target).value"
        aria-label="End time">
        <option *ngFor="let slot of timeOptions" [value]="slot" [selected]="slot === customTime">{{ slot }}</option>
      </select>
    </div>
    <p class="ds-error" *ngIf="customError; else summary">{{ customError }}</p>
    <ng-template #summary><p class="ds-summary">{{ customSummary }}</p></ng-template>
  </div>
</div>
